import { IPageConfigBase } from 'redux-state/layout/types.page.js';
import { getDocument } from 'utilities/window.js';
import { defaultRawMetaData, getMetaData } from 'vendor/meta-data.js';
import { clearPreviousTags, setHeaderLinkEls, setHeaderMetaEls } from './set-tags-utils.js';

export type MetaDataRaw = {
  [x: string]: MetaDataConfig & {
    content: string;
  };
};

/** Remove null values from object */
const removeEmpty = <T extends Record<string, unknown>>(obj: T): T => {
  const shallowCopy = { ...obj };
  Object.keys(shallowCopy).forEach((k) => shallowCopy[k] == null && delete shallowCopy[k]);
  return shallowCopy;
};

/** Update headers meta tags */
const setTagsInit = (
  previousMetaData: MetaDataRaw = getMetaData(defaultRawMetaData()),
): ((p: IPageConfigBase['metadata']) => void) => {
  return (_pageMetaData: IPageConfigBase['metadata'] = {}) => {
    clearPreviousTags(previousMetaData);
    /** We remove null values from the pageMetaData object, this is as ther */
    const pageMetaObj = getMetaData(removeEmpty(_pageMetaData));
    const defaultMetaObj = getMetaData(defaultRawMetaData());
    const newPageMetadata = { ...defaultMetaObj, ...pageMetaObj };

    /**  Set the title for the page */
    if (newPageMetadata['title']) {
      const document = getDocument();
      if (document) {
        document.title = newPageMetadata['title'].content;
      }
    }
    // Loop through the supported list of tags
    setHeaderMetaEls(newPageMetadata);
    setHeaderLinkEls(_pageMetaData);
    previousMetaData = newPageMetadata;
  };
};

export { setTagsInit };
